module.exports = __webpack_public_path__ + "img/undraw_houses3_xwf7.8e822f7d.svg";